module.exports = __webpack_public_path__ + "images/Tufin-71a706.png";